module.exports = __webpack_public_path__ + "static/qc-85534db9afb08a3220a14991fec22279.jpg";